'use client';

import { initDatadog } from '@/lib/datadog-browser';
import { useEffect } from 'react';

export default function DatadogInit() {
    useEffect(() => {
        void initDatadog().catch(() => undefined);
    }, []);

    return null;
}
